var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#826AF9",
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#826AF9",
    fillRule: "evenodd",
    d: "M.882 7.631a7.504 7.504 0 0 1 14.236-.004c.08.241.08.501 0 .742a7.503 7.503 0 0 1-14.235.004c-.08-.24-.08-.5 0-.742M11.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0",
    clipRule: "evenodd"
  })));
};
export default SvgEye;